import { gql } from "@apollo/client";

export interface IAdminReleaseProfileVars {
  profileId: string;
}

export const ADMIN_RELEASE_PROFILE = gql`
  mutation adminReleaseProfile($profileId: String!) {
    adminReleaseProfile(profileId: $profileId)
  }
`;
